export enum PromoCodeApplicationEnum {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC'
}

export const promoCodeApplicationMapping: Record<PromoCodeApplicationEnum, string> = {
  [PromoCodeApplicationEnum.MANUAL]: 'Manuelle',
  [PromoCodeApplicationEnum.AUTOMATIC]: 'Automatique'
}
